export const inr = (n: number | null | undefined, digits = 0) =>
  n == null ? '—' : new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: digits, minimumFractionDigits: digits }).format(n);

export const num = (n: number | null | undefined, digits = 1) =>
  n == null ? '—' : new Intl.NumberFormat('en-IN', { maximumFractionDigits: digits }).format(n);

export const fmtDate = (d: string | null | undefined) => {
  if (!d) return '—';
  const dt = new Date(d.length === 10 ? `${d}T00:00:00` : d);
  return dt.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const fmtTime = (d: string | null | undefined) =>
  !d ? '—' : new Date(d).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' });

export const minutesToHm = (m: number | null | undefined) => {
  if (!m) return '0h 00m';
  return `${Math.floor(m / 60)}h ${String(m % 60).padStart(2, '0')}m`;
};

export const periodLabel = (p: string) => {
  const [y, m] = p.split('-').map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString('en-IN', { month: 'long', year: 'numeric' });
};

export const currentPeriod = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

export const currentFinancialYear = (d = new Date()) => {
  const y = d.getMonth() >= 3 ? d.getFullYear() : d.getFullYear() - 1;
  return `${y}-${String((y + 1) % 100).padStart(2, '0')}`;
};

export const statusTone = (s: string): 'success' | 'warning' | 'danger' | 'info' | 'neutral' => {
  if (['approved', 'present', 'active', 'paid', 'resolved', 'locked'].includes(s)) return 'success';
  if (['pending', 'half_day', 'probation', 'notice', 'in_progress', 'processed', 'draft', 'open'].includes(s)) return 'warning';
  if (['rejected', 'absent', 'exited', 'cancelled'].includes(s)) return 'danger';
  if (['leave', 'half_leave', 'holiday', 'onboarding'].includes(s)) return 'info';
  return 'neutral';
};
